import React, { useContext, useEffect } from 'react';
import GlobalContext from 'hooks/contexts/GlobalContext';
import ClickPortalResultRowsList from 'components/sections/clickPortalResultRows/ClickPortalResultRowsList';
import { initImpressionDebugging } from 'app-requests/clickPortalSchoolManager';
import { CLICK_PORTAL_CARD_LAYOUT } from 'consts';
import ClickPortalVerticalResults from './ClickPortalVerticalResults';

export default function ClickPortalResults({
  cardLayout,
  isVerticalList = false,
}: {
  cardLayout?: CLICK_PORTAL_CARD_LAYOUT;
  isVerticalList?: boolean;
} = {}): React.ReactNode {
  const {
    clickPortal: { isLoading, resultRows },
    siteMeta: { clickPortalSettings },
  } = useContext(GlobalContext);

  useEffect(() => {
    initImpressionDebugging();
  }, []);

  if (!isVerticalList && clickPortalSettings?.isMultiRow) {
    return (
      <section className="clickPortalResultRowsSection clickPortalResultRowsSection--isMultiRow">
        <div className="clickPortalResultRowsSection__inner">
          {resultRows?.map((resultRow, index) => (
            <ClickPortalResultRowsList
              // It is possible impression has not been loaded yet so leverage index until it is
              key={`${resultRow.title}-${resultRow.subTitle || index}-${
                resultRow.schoolImpressionGroupGuid
              }`}
              resultRow={resultRow}
              isLoading={isLoading}
              rowIndex={index}
            />
          ))}
        </div>
      </section>
    );
  }

  return <ClickPortalVerticalResults cardLayout={cardLayout} />;
}
